import { useState, useEffect } from 'react';
import { collection, query, orderBy, onSnapshot, addDoc, updateDoc, doc, deleteDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { MedicalRecord } from '../types';
import { toast } from 'react-hot-toast';

export function useMedicalRecords() {
  const [medicalRecords, setMedicalRecords] = useState<MedicalRecord[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, 'medicalRecords'), orderBy('date', 'desc'));
    
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const recordsData = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      })) as MedicalRecord[];
      
      setMedicalRecords(recordsData);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const addMedicalRecord = async (recordData: Omit<MedicalRecord, 'id' | 'createdAt' | 'updatedAt'>) => {
    try {
      const now = new Date().toISOString();
      await addDoc(collection(db, 'medicalRecords'), {
        ...recordData,
        createdAt: now,
        updatedAt: now
      });
      toast.success('Prontuário criado com sucesso!');
    } catch (error) {
      console.error('Erro ao criar prontuário:', error);
      toast.error('Erro ao criar prontuário');
      throw error;
    }
  };

  const updateMedicalRecord = async (id: string, recordData: Partial<MedicalRecord>) => {
    try {
      await updateDoc(doc(db, 'medicalRecords', id), {
        ...recordData,
        updatedAt: new Date().toISOString()
      });
      toast.success('Prontuário atualizado com sucesso!');
    } catch (error) {
      console.error('Erro ao atualizar prontuário:', error);
      toast.error('Erro ao atualizar prontuário');
      throw error;
    }
  };

  const deleteMedicalRecord = async (id: string) => {
    try {
      await deleteDoc(doc(db, 'medicalRecords', id));
      toast.success('Prontuário removido com sucesso!');
    } catch (error) {
      console.error('Erro ao remover prontuário:', error);
      toast.error('Erro ao remover prontuário');
      throw error;
    }
  };

  return {
    medicalRecords,
    loading,
    addMedicalRecord,
    updateMedicalRecord,
    deleteMedicalRecord
  };
}